import { KeyboardKey } from './models/KeyboardKey';
var KeysToKeyboardKeys = {
    Tab: KeyboardKey.Tab,
    Enter: KeyboardKey.Enter,
    Shift: KeyboardKey.Shift,
    Esc: KeyboardKey.Escape,
    Escape: KeyboardKey.Escape,
    Space: KeyboardKey.Space,
    Left: KeyboardKey.ArrowLeft,
    ArrowLeft: KeyboardKey.ArrowLeft,
    Up: KeyboardKey.ArrowUp,
    ArrowUp: KeyboardKey.ArrowUp,
    Right: KeyboardKey.ArrowRight,
    ArrowRight: KeyboardKey.ArrowRight,
    Down: KeyboardKey.ArrowDown,
    ArrowDown: KeyboardKey.ArrowDown,
    Zero: KeyboardKey.Zero,
    Nine: KeyboardKey.Nine,
    a: KeyboardKey.A,
    z: KeyboardKey.Z,
    A: KeyboardKey.A,
    Z: KeyboardKey.Z,
    ContextMenu: KeyboardKey.ContextMenu,
    '/': KeyboardKey.Slash,
    F10: KeyboardKey.F10,
    Home: KeyboardKey.Home,
    End: KeyboardKey.End,
};
var KeyCodesToKeyboardKeys = {
    9: KeyboardKey.Tab,
    13: KeyboardKey.Enter,
    16: KeyboardKey.Shift,
    27: KeyboardKey.Escape,
    32: KeyboardKey.Space,
    35: KeyboardKey.End,
    36: KeyboardKey.Home,
    37: KeyboardKey.ArrowLeft,
    38: KeyboardKey.ArrowUp,
    39: KeyboardKey.ArrowRight,
    40: KeyboardKey.ArrowDown,
    48: KeyboardKey.Zero,
    57: KeyboardKey.Nine,
    65: KeyboardKey.A,
    90: KeyboardKey.Z,
    93: KeyboardKey.ContextMenu,
    121: KeyboardKey.F10,
    191: KeyboardKey.Slash,
};
export function getKey(event) {
    return (KeysToKeyboardKeys[event.key] ||
        KeyCodesToKeyboardKeys[event.keyCode] ||
        KeyboardKey.Unknown);
}
//# sourceMappingURL=getKey.js.map